import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default class BannerSlider {

    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind() {

        this.$view.slick({
            arrows: false,
            dots: true,
            infinite: true,
            fade: true
        });

    }

}